import { Card } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from './PageHeader';
import { EmptyState } from './EmptyState';

/**
 * Vaqtincha muzlatilgan bo'lim holati.
 *
 * Bayroq bilan o'chirilgan sahifa (masalan `lib/features.ts` →
 * `PREMIUM_UI_ENABLED = false`) marshrutdan OLIB TASHLANMAYDI: yon menyuda
 * ko'rinmasa ham, to'g'ridan-to'g'ri URL bilan kirish mumkin. Shunda oq ekran
 * yoki server xatosi emas, aynan shu tushuntirish ko'rinadi.
 *
 * `titleKey` — sahifaning O'Z sarlavha kaliti (masalan `premiumPage.title`),
 * shunda foydalanuvchi qaysi bo'limga kirganini yo'qotmaydi.
 */
export function FeatureFrozen({ titleKey }: { titleKey?: string }) {
  const { t } = useTranslation();
  /* `padding={0}` — sabab `SectionCard.tsx` dagi izohda. */
  return (
    <>
      <PageHeader title={t(titleKey ?? 'featureFrozen.title')} />
      <Card padding={0}>
        <EmptyState icon={IconLock} title={t('featureFrozen.title')} description={t('featureFrozen.desc')} />
      </Card>
    </>
  );
}
